import React from 'react';
import { useIntl } from 'umi';
import { Select } from 'tea-component';

type TReferenceLineStyle = 'dotted' | 'dashed' | 'solid';

interface ILineTypeProps {
  lineWidth?: string | number;
  type?: TReferenceLineStyle;
  label?: React.ReactNode;
  lineColor?: string;
}

const LineType: React.FC<ILineTypeProps> = ({
  lineWidth = '100%',
  type = 'dotted',
  label,
  lineColor,
}) => {
  const dashConfigs: Record<TReferenceLineStyle, string> = {
    dotted: '2, 1',
    dashed: '5, 3',
    solid: 'none',
  };

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
      }}
    >
      <svg width={lineWidth} height="1">
        <line
          x1="0"
          y1="1"
          x2="100%"
          y2="1"
          stroke={lineColor || 'black'}
          strokeWidth="2"
          strokeDasharray={dashConfigs[type] || dashConfigs.dotted}
        />
      </svg>
      <span>{label}</span>
    </div>
  );
};

interface ILineTypeSelectorProps {
  value?: string;
  onChange?: (value: string) => void;
}

const LineTypeSelector: React.FC<ILineTypeSelectorProps> = ({
  value,
  onChange,
}) => {
  const { formatMessage } = useIntl();

  const options = [
    {
      value: 'dashed',
      text: (
        <LineType
          lineWidth={88}
          type="dashed"
          label={formatMessage({
            id: 'dbl_chart_advanced_reference_line_dashed',
          })}
          lineColor={value === 'dashed' ? '#326FF0' : '#BBBDCB'}
        />
      ),
    },
    {
      value: 'solid',
      text: (
        <LineType
          lineWidth={88}
          type="solid"
          label={formatMessage({
            id: 'dbl_chart_advanced_reference_line_solid',
          })}
          lineColor={value === 'solid' ? '#326FF0' : '#BBBDCB'}
        />
      ),
    },
  ];

  return (
    <Select
      matchButtonWidth
      style={{ width: '100px', flex: '1 1 0px', marginRight: '10px' }}
      appearance="button"
      options={options}
      value={value}
      onChange={onChange}
      button={
        <LineType
          type={value as TReferenceLineStyle}
          label={formatMessage({
            id: `dbl_chart_advanced_reference_line_${value}`,
          })}
          lineColor="#838697"
          lineWidth={70}
        />
      }
    />
  );
};

export default React.memo(LineTypeSelector);
